module.exports = __webpack_public_path__ + "img/resource-tab.62f91ffa.png";